import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { useOverflown } from "../../../core/hooks/useOverflown";
import { Tooltip } from "../../floating";
import { cssBody200Bold, cssDisplay100Bold } from "../../typography/styles";
export const MainTitle = memo(({ size = "100", titleLineClamp = 2, tooltipOptions, overflowTitleTooltip = true, onTitleClick, openTitleLinkInNewTab = false, product, titleTooltipContent, titleTestId, }) => {
    const { isOverflown, checkOverflown } = useOverflown();
    const title = useMemo(() => product?.hrefTitle ? (_jsx(LinkTitle, { "data-testId": titleTestId, "$clamp": titleLineClamp, "$size": size, href: product?.hrefTitle, onClick: onTitleClick, onMouseEnter: checkOverflown, ...(openTitleLinkInNewTab ? { target: "_blank", rel: "noreferrer" } : {}), children: product?.title })) : product?.toTitle ? (_jsx(RouterLinkTitle, { "data-testId": titleTestId, "$clamp": titleLineClamp, "$size": size, to: product?.toTitle, onClick: onTitleClick, onMouseEnter: checkOverflown, ...(openTitleLinkInNewTab ? { target: "_blank", rel: "noreferrer" } : {}), children: product?.title })) : (_jsx(Title, { "data-testId": titleTestId, "$clamp": titleLineClamp, "$size": size, onMouseEnter: overflowTitleTooltip ? checkOverflown : undefined, children: product?.title })), [
        checkOverflown,
        onTitleClick,
        openTitleLinkInNewTab,
        overflowTitleTooltip,
        product?.hrefTitle,
        product?.toTitle,
        product?.title,
        size,
        titleLineClamp,
        titleTestId,
    ]);
    return overflowTitleTooltip ? (_jsx(Tooltip, { placement: "top", content: titleTooltipContent ?? product?.title, appendTo: document.body, maxWidth: 500, disabled: isOverflown, ...tooltipOptions, children: title })) : (title);
});
const titleTypography = {
    100: cssBody200Bold,
    400: cssDisplay100Bold,
    dropdown: cssBody200Bold,
};
const linkStyle = css `
  ${({ $size }) => titleTypography[$size]};

  color: ${({ theme }) => theme.systemColors.blue600};
  line-height: 1.29;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${(p) => p.$clamp};
  -webkit-box-orient: vertical;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.systemColors.blue800};
  }
`;
const RouterLinkTitle = styled(Link) `
  ${linkStyle}
`;
const LinkTitle = styled.a `
  ${linkStyle}
`;
const Title = styled.div `
  ${({ $size }) => titleTypography[$size]};

  color: ${({ theme }) => theme.systemColors.black};
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: ${(p) => p.$clamp};
  -webkit-box-orient: vertical;
`;
